<template>
  <div class="minitest">
    <div class='inner-box' v-if='cur_data.chapter_type == 2'>
      <Header>
        <h4>{{cur_data.chapter_title}}</h4>
      </Header>
      <!-- 答案显示结果 -->
      <div :class='{right:cur_data.answer_right,wrong:!cur_data.answer_right}' class="answer_result"  v-show="cur_data.answerShow" v-if='cur_data.chapter_content.quiz_type==1 || cur_data.chapter_content.quiz_type==2'><i></i>{{cur_data.answer_right? $t('answerTrue'):$t('answerFalse')}} <a href="javascript:;" @click='feedBackShow=!feedBackShow'>{{feedBackShow ? $t('turnOff'):$t('view')}} {{$t('answerFeedback')}}</a> </div>
      <div class="result-feedback" v-show="feedBackShow">
        <div class="feedback-con" v-if='cur_data.answer_right' v-html="cur_data.chapter_content.feedback.right"></div>
        <div class="feedback-con" v-else v-html="cur_data.chapter_content.feedback ? cur_data.chapter_content.feedback.wrong : '' "></div>
      </div>
      <!-- :key='$route.query.chapter_id' -->
      <v-drag ref="vDrag"  :key='$route.query.chapter_id'  v-if='cur_data.chapter_content.quiz_type==4 || cur_data.chapter_content.quiz_type==5'>
        <template slot="btn">
          <div class="test_submit" :class="cur_data.chapter_content.quiz_type==4 || cur_data.chapter_content.quiz_type==5?'test_submit_drag':''">
            <div class="submit_done" v-show="cur_data.answerShow">
              <a class="sub" :class="{cur:cur_data.idx==1}" v-show="cur_data.chapter_id!=firstChapterId" @click="checkChapter('prev',cur_chap_index,cur_part_index)">{{$t('prevChapter')}}</a>
              <a class="sub" :class="{cur:cur_data.idx==1}" v-show="cur_data.chapter_id==firstChapterId" @click="lookHeadVideo">{{$t('prevChapter')}}</a>
              <a class="next" v-show="cur_data.chapter_id!=lastChapterId" @click="checkChapter('next',cur_chap_index,cur_part_index)">{{$t('nextChapter')}}</a>
              <a class="next" v-show="cur_data.chapter_id==lastChapterId" @click="lookFootVideo">{{$t('nextChapter')}}</a>
            </div>
            <div class="unsubmit" v-show="!cur_data.answerShow">
              <a class="sub" v-show="cur_data.chapter_id!=firstChapterId" @click="checkChapter('prev',cur_chap_index,cur_part_index)">{{$t('prevChapter')}}</a>
              <a class="sub" v-show="cur_data.chapter_id==firstChapterId" @click="lookHeadVideo">{{$t('prevChapter')}}</a>
              <a class="submit" @click="testSubmit()">{{$t('submit')}}</a>
              <a class="next" @click="checkChapter('next',cur_chap_index,cur_part_index)" v-show="cur_data.chapter_id!=lastChapterId">{{$t('nextChapter')}}</a>
              <a class="next" @click="lookFootVideo" v-show="cur_data.chapter_id==lastChapterId">{{$t('nextChapter')}}</a>
            </div>
          </div>
        </template>
      </v-drag>
      <v-select ref="vSelect" :key='$route.query.chapter_id' v-if='cur_data.chapter_content.quiz_type==1 || cur_data.chapter_content.quiz_type==2'></v-select>
      <v-fillin ref="vFillin" :key='$route.query.chapter_id' v-if='cur_data.chapter_content.quiz_type==6 || cur_data.chapter_content.quiz_type==7 || cur_data.chapter_content.quiz_type==3'></v-fillin>
      <v-judge ref="vJudge"  :key='$route.query.chapter_id' v-if='cur_data.chapter_content.quiz_type==8'></v-judge>
      <div class="test_submit" v-if="cur_data.chapter_content.quiz_type!=4 && cur_data.chapter_content.quiz_type!=5">
          <div class="submit_done" v-show="cur_data.answerShow">
            <a class="sub" :class="{cur:cur_data.idx==1}" v-show="cur_data.chapter_id!=firstChapterId" @click="checkChapter('prev',cur_chap_index,cur_part_index)">{{$t('prevChapter')}}</a>
            <a class="sub" :class="{cur:cur_data.idx==1}" v-show="cur_data.chapter_id==firstChapterId" @click="lookHeadVideo">{{$t('prevChapter')}}</a>
            <a class="next" v-show="cur_data.chapter_id!=lastChapterId" @click="checkChapter('next',cur_chap_index,cur_part_index)">{{$t('nextChapter')}}</a>
            <a class="next" v-show="cur_data.chapter_id==lastChapterId" @click="lookFootVideo">{{$t('nextChapter')}}</a>
          </div>
          <div class="unsubmit" v-show="!cur_data.answerShow">
            <a class="sub" v-show="cur_data.chapter_id!=firstChapterId" @click="checkChapter('prev',cur_chap_index,cur_part_index)">{{$t('prevChapter')}}</a>
            <a class="sub" v-show="cur_data.chapter_id==firstChapterId" @click="lookHeadVideo">{{$t('prevChapter')}}</a>
            <a class="submit" @click="testSubmit()">{{$t('submit')}}</a>
            <a class="next" @click="checkChapter('next',cur_chap_index,cur_part_index)" v-show="cur_data.chapter_id!=lastChapterId">{{$t('nextChapter')}}</a>
            <a class="next" @click="lookFootVideo" v-show="cur_data.chapter_id==lastChapterId">{{$t('nextChapter')}}</a>
          </div>
      </div>
      <div class="drag-blink" ></div>

    </div>
  </div>
</template>
<script>
import Header from 'components/H5/Header.vue'
import vSelect from './select.vue'
import vJudge from './judge.vue'
import vFillin from './fillin.vue'
import vDrag from './drag.vue'

import mixins from 'components/H5/mixins/compon.js'
export default {
  name: 'minitest',
  mixins: [mixins],
  data () {
    return {
      quiz_type: 1,
      lastChapterId: '', // 最后一章节
      firstChapterId: '', // 第一章节
      checkedChapterType: '', // 切换后章节类型
      feedBackShow: false // 测试反馈显示框
    }
  },
  components: {
    Header,
    vSelect,
    vJudge,
    vFillin,
    vDrag
  },
  computed: {
    cur_data () {
      return this.$store.state.cur_data
    },
    next_data () {
      return this.$store.state.next_data
    },
    cur_chap_index () {
      return this.$store.state.currentChapterIndex
    },
    cur_part_index () {
      return this.$store.state.currentPartIndex
    }

  },
  created () {
    this.lastChapterId = JSON.parse(JSON.stringify(this.data)).part_list[ this.data.part_list.length - 1].chapter_list.pop().chapter_id
    this.firstChapterId = this.data.part_list[0].chapter_list[0].chapter_id
  },
  watch: {
    cur_data (o, n) {
      this.getChapterAnswer()
      this.$forceUpdate()
    },
    feedBackShow (n) {
      if (n) {
        $('.minitest').addClass('model-open')
      } else {
        $('.minitest').removeClass('model-open')
      }
    },
    $route (newVal) {
      this.setLessonLocation(this.cur_part_index, this.cur_chap_index, false)
    }
  },
  mounted () {
    // this.setLessonLocation(this.cur_part_index, this.cur_chap_index, false)
    this.$nextTick(() => {
      this.getChapterAnswer()
      this.$forceUpdate()
      $('.minitest').animate({ scrollTop: 0 }, 50)
      if ($('#appH5R')) {
        $('#appH5R').animate({ scrollTop: 0 }, 50)
      }
    })
  },
  methods: {
    testSubmit () {
      let chapterType = Number(this.cur_data.chapter_content.quiz_type)
      if (chapterType === 1 || chapterType === 2) {
        this.$refs.vSelect.submit()
      } else if (chapterType === 3 || chapterType === 6 || chapterType === 7) {
        this.$refs.vFillin.submit()
      } else if (chapterType === 4 || chapterType === 5) {
        this.$refs.vDrag.submit()
      } else {
        this.$refs.vJudge.submit()
      }
      /* 存小节学习状态 */
      // this.setLessonLocation(this.cur_part_index, this.cur_chap_index, false)
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
  .minitest {
    font-size: 0.26rem;
    height: 100%;
    overflow:auto;
    -webkit-overflow-scrolling: touch;
    &.model-open {
      position: fixed;
      width: 100%;
      height:auto;
      min-height: 100%;
    }
    .inner-box{
      // height:auto;
      height: 100%;
      position: relative;
    }
    .answer_result {
        width:100%;
        height: 1.15rem;
        line-height: 1.15rem;
        font-size:.3rem;
        color:#fff;
        box-sizing: border-box;
        i {
          display: inline-block;
          width: .44rem;
          height: .44rem;
          vertical-align: middle;
          margin:0 .2rem 0 .5rem;
          border-radius: 50%;
        }
        &.right {
          background-color: #4AA854;
          i {
            background:url('../../../assets/img/h5/pass.png') no-repeat center / contain;
          }
        }
        &.wrong {
          background-color: #F75D5D;
          i {
            background: url('../../../assets/img/h5/unpass.png') no-repeat center / contain;
          }
        }
        a {
          color: #fff;
          float:right;
          font-size: .2rem;
          text-decoration:underline;
          margin: .2rem;
          line-height:.72rem;
        }
      }
    .result-feedback {
      width: 100%;
      height: calc(100vh - 1.87rem);
      position: absolute;
      // top: 1.87rem;
      background-color: rgba(0,0,0,.3);
      z-index: 100;
      .feedback-con {
        background-color: #fff;
        min-height:.72rem;
        padding: .5rem;
        box-sizing: border-box;
      }
    }
    /* 兼容苹果手机margin-bottom不起作用 */
     .drag-blink {
      // height:3rem;
      width:100%;
    }
    .test_submit {
        padding:0.4rem 0.5rem;
        height: 2.2rem;
        background: white;
        // box-sizing: border-box;
        // margin-bottom:3rem;
        .unsubmit {
          display: flex;
          align-items: center;
          font-size: .3rem;
          .sub,.next {
            display: inline-block;
            text-align: center;
            width: 1.6rem;
            line-height: .74rem;
            border:.02rem solid #005587;
            color: #005587;
            border-radius:0.06rem;
            vertical-align: middle;
            // box-sizing: border-box;
            &.yc {
              visibility: hidden;
            }
          }
          .submit {
            flex: 1;
            line-height: .78rem;
            background-color: @basic-color;
            border-radius:0.06rem;
            margin: 0 .3rem;
            color: #fff;
            text-align: center;
            vertical-align: middle;
          }
        }
        .submit_done {
          .sub {
            color: @basic-color;
            background-color: #fff;
          }
          .next {
            float: right;
            color: @basic-color;
            background-color: #fff;
          }
          .sub,.next {
            width:3.12rem;
            border:1px solid @basic-color;
            border-radius:0.06rem;
            text-align: center;
            line-height: .78rem;
            display: inline-block;
            font-size: 0.32rem;
            &.cur {
              border:1px solid #ccc;
              color: #ccc;
              opacity:.8;
            }
          }

        }
      }
      .test_submit_drag{
        height:3.4rem;
      }

  }
</style>
